import { AST } from '@handlebars/parser';
import { concatenate, joinWithSpaces } from 'utils/stringHelpers';
import { ExpressionSerializer } from '../../expression/serializer';
import { PARTIAL_PATH_PREFIX } from '../constants';
import { StatementArgsSerializer } from './args';
import { serializeHandlebar } from '../../../utils/serializeHandlebar';

export class PartialStatementSerializer {
  static serialize = (statement: AST.PartialStatement) => {
    const nameAndPrefix = concatenate([
      PARTIAL_PATH_PREFIX,
      ExpressionSerializer.serialize(statement.name),
    ]);
    const handlebar = serializeHandlebar(
      joinWithSpaces([nameAndPrefix, StatementArgsSerializer.serialize(statement)]),
      statement.strip,
    );
    return concatenate([statement.indent, handlebar]);
  };
}
